(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/video-player/assets/javascripts/video-stat.js') >= 0) return;  svs.modules.push('/components/components/video-player/assets/javascripts/video-stat.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components.analytics = svs.components.analytics || {};

  svs.components.analytics.videoStart = function(evt) {
    var dataLayerData = {
      event: 'video',
      eventInfo: {
        type: 'Video',
        eventAction: 'Start',
        eventName: evt.videoName
      }
    };

    dataLayerPush(dataLayerData);

    var msg = new svs.core.log.Message(svs.core.log.MessageType.event);

    msg.eventAction = 'Start';
    msg.eventLabel = evt.videoName;
    msg.eventCategory = 'Video';
    msg.eventValue = 1;
    svs.core.log.track('svs.components.analytics', msg);
  };

  svs.components.analytics.videoTick = function(evt) {
    var dataLayerData = {
      event: 'video',
      eventInfo: {
        type: 'Video',
        eventAction: evt.progress,
        eventName: evt.videoName
      }
    };

    dataLayerPush(dataLayerData);

    var msg = new svs.core.log.Message(svs.core.log.MessageType.event);

    msg.eventAction = 'Progress';
    msg.eventLabel = evt.videoName;
    msg.eventCategory = 'Video';
    msg.eventValue = evt.progress;
    svs.core.log.track('svs.components.analytics', msg);
  };
})(svs);

 })(window);